import api from './api';

/**
 * @param {string} skill
 * @param {string} taskType
 * @param {string} rubricId
 * @returns {Promise<{
*   rubric_id: string
*   rubric_text: string
*   helper_text: string
*   rubric_audio_id: string
*   helper_audio_id: string
*   skill_id: string
*   level_id: string
*   phase: string
*   task_type_id: string
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Rubrics-getOneRubric
 */
export default async function getRubric(rubricId) {
    const { data } = await api.get(
        `rubrics/${rubricId}`
    );

    return data;
}